import React from 'react'
import {Button, Layout, Result} from "antd";
import {Link} from "react-router-dom";
const { Content } = Layout;

class SuccessContent extends React.Component{
    constructor(props) {
        super(props);
    }
    render() {
        return <div>
            <Layout className="site-layout-background" style={{ padding: '24px 0',width: '1000px',margin: '0 auto'  }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <Result
                        status="success"
                        title={`${this.props.history.location.state?this.props.history.location.state.data:'Successful'}`}
                        // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
                        extra={[
                            <Button type="primary" key="console">
                                <Link to={'/disputeHome'}>Go Home page</Link>
                            </Button>,
                            <Button type="primary" onClick={()=>{
                                this.props.history.goBack()
                            }}>
                                Return
                            </Button>,
                        ]}
                    />
                </Content>
            </Layout>
        </div>

    }
}

export default SuccessContent;